import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { useTranslation } from "react-i18next";

import { customCell, dateCell, GridPanel } from "@selas/ui-components";

import style from "../../../../../assets/editor.module.scss";
import Endpoint from "../../../../../services/api/endpoint";
import { hasPermission } from "../../../../../services/authentication";
import { Permission } from "../../../../../utils/enums";
import EmailEditor from "../../../followup/email";

interface IProps {
	groupId: number;
	projectId: number;
}

const GroupEmails: React.FC<IProps> = (props: IProps) => {
	const { t } = useTranslation();

	return (
		<GridPanel
			className={style.tabGrid}
			listEndpoint={Endpoint.GroupEmailsList}
			listUrlArguments={{ groupId: props.groupId }}
			endpoint={Endpoint.GroupEmails}
			editScreen={{ screen: EmailEditor, isAllowed: true, extraProps: { groupId: props.groupId, projectId: props.projectId } }}
			delete={{ urlArguments: { groupId: props.groupId }, isAllowed: hasPermission(Permission.ProjectsUpdate) }}
			localLoader
			sort={[{ field: "createdDate", dir: "desc" }]}
		>
			<GridColumn field="createdDate" title={t("createdOn")} cell={customCell(dateCell("yyyy-MM-dd HH:mm"))} filter="date" />
			<GridColumn field="creator.fullName" title={t("creator")} />
			<GridColumn field="to" title={t("to")} />
			<GridColumn field="cc" title={t("cc")} />
			<GridColumn field="bcc" title={t("bcc")} />
			<GridColumn field="subject" title={t("subject")} />
			<GridColumn field="body" title={t("body")} />
		</GridPanel>
	);
};

export default GroupEmails;
